import { render, staticRenderFns } from "./StatusToggleBtns.vue?vue&type=template&id=27d588c1"
import script from "./StatusToggleBtns.vue?vue&type=script&lang=ts"
export * from "./StatusToggleBtns.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports